import { useState, type ReactNode } from 'react';
import { NeonLoadingIndicator, NeonSystemMessage, NeonTabs } from '@ps-refarch-ux/neon';
import { StatusTag } from '../neon/controls';
import { useDomId } from '../hooks/useDomId';

export function LoadingBlock({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="loading">
      <NeonLoadingIndicator dataSize="large" />
      <span>{label}</span>
    </div>
  );
}

export function ErrorBanner({ error }: { error?: string | null }) {
  const id = useDomId('msg');
  if (!error) return null;
  return (
    <NeonSystemMessage id={id} dataType="error" dataTitle="Error" dataSize="full-width">
      {error}
    </NeonSystemMessage>
  );
}

export function SuccessBanner({ message }: { message?: string | null }) {
  const id = useDomId('msg');
  if (!message) return null;
  return (
    <NeonSystemMessage id={id} dataType="success" dataSize="full-width">
      {message}
    </NeonSystemMessage>
  );
}

export { StatusTag as StatusBadge };

export interface TabDef {
  id: string;
  label: string;
  content: ReactNode;
}

export function Tabs({ tabs, initial }: { tabs: TabDef[]; initial?: string }) {
  const groupId = useDomId('tabs');
  const [active, setActive] = useState(initial ?? tabs[0]?.id);
  const current = tabs.find((t) => t.id === active) ?? tabs[0];
  const neonTabs = tabs.map((t) => ({ id: t.id, text: t.label }));
  return (
    <div className="tabs">
      <NeonTabs
        id={groupId}
        tabs={neonTabs}
        currentTab={active}
        dataLegend="Section tabs"
        tabSelectionChanged={(t) => setActive(t ?? tabs[0]?.id)}
      />
      <div className="tab-panel" role="tabpanel">
        {current?.content}
      </div>
    </div>
  );
}
